export default "__VITE_ASSET__C6q5k80y__"